import RoomPageBase from './room-page-base'
import stimulus from 'lib/stimulus-instance'
import GlideSliderController from 'frontend/controllers/glide-slider-controller'
import React from 'react'
import ReactDOM from 'react-dom'
import moment from 'lib/moment-timezone-custom'
import clickToPlayWrap from 'lib/click-to-play-wrap'
import ScheduleComponent from 'frontend/pages/rooms/hhla-schedule-base'
import Reviews from 'frontend/pages/rooms/reviews'

stimulus.register('glide-slider', GlideSliderController)

export default class HhlaPageBase extends RoomPageBase {
  static async initVideo () {
    if (this.videoInitialized) return

    document.querySelectorAll('.video-reviews .video_container').forEach(el => clickToPlayWrap(el))
    this.videoInitialized = true
  }

  // Reviews.init would mount a second Glide on the slider; only its modal is reused.
  // onEnter fires once per matching section, so every section is set up on the first call.
  static initReadMore () {
    if (this.readMoreInitialized) return
    this.readMoreInitialized = true

    // Glide sets slide widths after this runs and again on resize
    const observer = new ResizeObserver(entries => entries.forEach(({ target }) => {
      target.closest('.review').classList.toggle('has_more', target.scrollHeight > target.clientHeight + 1)
    }))
    document.querySelectorAll('.reviews_and_rating .review .body').forEach(body => observer.observe(body))
    document.addEventListener('click', ({ target }) => {
      const button = target.closest('.reviews_and_rating .read_more')
      if (button) Reviews.showFullReview(button.closest('.review'))
    })
  }

  static async mountRoomSchedule () {
    if (this.roomScheduleMounted || !this.scheduleRoot) return

    this.roomScheduleMounted = true

    ReactDOM.render(
      React.createElement(
        ScheduleComponent,
        {
          roomId: parseInt(this.props.roomId),
          openedFrom: moment(this.props.openedFrom),
          prebookingCodeOnly: this.props.prebookingCodeOnly !== undefined,
        },
      ),
      this.scheduleRoot,
    )
  }

  static handleStylesApplied () {
    this.onEnter('.video_container', this.initVideo.bind(this))
    this.onEnter('.reviews_and_rating', () => this.initReadMore())
    this.mountRoomSchedule()
  }

  static get props () {
    return document.body.dataset
  }
}
